import React from "react"
import { Hit } from "../../../store/ProductStore"
import { SlotContentItem, VariationContent } from "../../../types/cms"
import { GridCardProps } from "../../../types/cms"
import { SlotItem } from "../../../types/cms"
/**
 * Calculates where to put the banner within the array of hits and inGridCards
 * @param screenSize string of the current device
 * @returns an array of numbers to show where to splice the hits
 */
export function calculateSlicePoints(screenSize?: string) {
  if (!screenSize) return []
  return screenSize === 'mobile' 
  ? [2, 5]
  : screenSize === 'tablet'
  ? [3, 9]
  : [5, 15]
}

/**
 * Calculates where each row/break should be, accounting for inGrid taking 2 grid spaces
 * @param items the array of hits and inGridCards
 * @param slicePoints where within the array the Category Row Slots should sit
 * @returns an array of numbers
 */
export function getRowSlices(items: (Hit | SlotContentItem)[], slicePoints: number[]) {
  const slices: number[] = []
  let virtualCount = 0
  let sliceIdx = 0

  for (let i = 0; i < items.length && sliceIdx < slicePoints.length; i++) {
    const item = items[i]
    // Slot takes 2, Hit takes 1
    virtualCount += isHitPromoGridCard(item) ? 2 : 1
    if (virtualCount >= slicePoints[sliceIdx] || items.length < slicePoints[sliceIdx] && i === (items.length -1)) {
      slices.push(i + 1)
      sliceIdx++
    }
  }
  return slices
}

export const isHitPromoGridCard = (hit: Hit | SlotContentItem): hit is SlotContentItem =>
    hit?.isInGridPromo

export const modifySlotInGridPromoCmsContent = (
    gridPromoContentData: SlotContentItem,
    gridCardProps: Partial<GridCardProps>,
  ) => {
    let gridVariationsContent: VariationContent<SlotItem[]>[] = []
    if (gridPromoContentData.variations && Array.isArray(gridPromoContentData.variations)) {
      gridVariationsContent = gridPromoContentData.variations.map((variation) => {
        const {contentItems, ...rest} = variation

        return {
          ...rest,
          contentItems: {...(contentItems || {}), ...gridCardProps},
        }
      })
    }
    
    const defaultContentArr = Array.isArray(gridPromoContentData.default)
      ? gridPromoContentData.default
      : [gridPromoContentData.default]

    const gridDefaultContent = defaultContentArr.map((defaultContentItem) => {
      return {...defaultContentItem, ...gridCardProps}
    })

    return {
      ...gridPromoContentData,
      variations: gridVariationsContent,
      default: gridDefaultContent,
      isInGridPromo: true,
    }
  }

// Create message for restricted products
export const createRestrictedMessage = (restrictedProductLimit: number | null) => {
    if (restrictedProductLimit === null) return
    if (restrictedProductLimit === 0) return 'This item is currently unavailable'
    if (restrictedProductLimit > 0) {
      const itemText = restrictedProductLimit > 1 ? 'items' : 'item'
      return `Only ${restrictedProductLimit} ${itemText} of this type allowed`
    }
  }

  /**
 * Calculates a virtual count for the number of present grid items as "promo" items take up more grid units than hits
 * @param items the array of hits and inGridCards
 * @returns number of for the grid item count
 */
  export const getVirtualGridCount = (items: React.ReactNode[]): number => {
    let virtualCount = 0
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      // Promo Slot takes 2 spaces per row, Hit takes 1
      const isPromo = React.isValidElement(item) && item.props?.gridItemType === 'promo'
      virtualCount += isPromo ? 2 : 1
    }
    return virtualCount
  }